import {historyInfoActionTypes} from "../_constants";
import {stateInitializer} from "./stateInitializer";
import Stack from "mnemonist/stack";

// initial state for the reducer
const initialState = stateInitializer.getHistoryInfoInitialState();

export function historyInfo(state = initialState, action) {

	switch (action.type) {

		// add to the history list
		case historyInfoActionTypes.PUSH:
			return push(state.list, action.location);

		// remove from the history list
		case historyInfoActionTypes.POP:
			return pop(state.list, action.location);

		default:
			return state;
	}
}

/**
 * Prepare the new list by appending new location
 *
 * @param list the old list
 * @param newLocation the new location to be added
 * @returns {*} updated list
 */
const push = (list, newLocation) => {
	// update new state list
	let newList = _deepClone(list);

	if(newList.current !== null) {          // if current is not empty
		newList.back.push(newList.current); // push current to back-stack
	}
	newList.current = newLocation;          // set current to new location
	newList.forward.clear();                // clear all the forward-stack

	return {
		list: newList,
		isDomainSafe: newList.back.size > 0
	};
};

/**
 * Prepare the new list by appending new location
 *
 * @param list the old list
 * @param currentLocation the current location
 * @returns {*} updated list
 */
const pop = (list, currentLocation) => {
	// update new state list
	let newList = _deepClone(list);

	const isBack = _peekInStack(newList.back, currentLocation);

	if(isBack) {    // if back
		newList.forward.push(newList.current);  // push the current to forward-stack
		newList.current = newList.back.pop();   // pop from the back-stack and make it current
	} else {        // if forward
		newList.back.push(newList.current);     // push the current to back-stack
		newList.current = newList.forward.pop();// pop from forward-stack and make it current
	}

	return {
		list: newList,
		isDomainSafe: newList.back.size > 0
	};
};

/**
 * Peeks if the given element is the next in list
 *
 * @param list 		the given list
 * @param element 	the given element
 * @returns {boolean} flag indicating if element is next item in list
 */
const _peekInStack = (list, element) => {
	let found = false;
	if(list && element && list.size > 0 && list.peek()) {
		found = list.peek().key === element.key;
	}
	return found;
};

/**
 * Returns a deep-cloned version of the current state list
 *
 * @param list the list of the state that hold current, back and forward links
 * @returns {any} cloned copy
 */
const _deepClone = (list) => {
	const rdfc = require('rfdc')();
	let listClone = rdfc(list);
	listClone.back = Stack.from(listClone.back.items);
	listClone.forward = Stack.from(listClone.forward.items);
	return listClone;
}